import { isElementNode, isTag } from 'anodum';
import { LINK_TAG } from '../constants/editable-elements';

const isLink = (element) => {
  if (!isElementNode(element)) return false;

  return isTag(element, LINK_TAG);
};

export default isLink;
